module.exports = __webpack_public_path__ + "img/20200508_173241.2d2f9ddf.jpg";